var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"register"},[_c('b-card',[_c('b-card-text',[_c('FormRegister',{attrs:{"payload":_vm.payload}}),_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.register}},[_vm._v("Register")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }